// extracted by mini-css-extract-plugin
module.exports = {"root":"CoverCard_root_ac_8j","content":"CoverCard_content_2dW38","logo":"CoverCard_logo_1XtwB","description":"CoverCard_description_2XyCZ","play":"CoverCard_play_1KDXv"};